function injectElevenLabsWidget(agentId, options = {}) {
    // Check if the widget is already loaded
    if (!agentId) {
        console.error('Eleven labs error: No AgentId')
        return;
    }

    const { firstMessage = false } = options;

    const script = document.createElement('script');
    script.src = 'https://unpkg.com/@elevenlabs/convai-widget-embed';
    script.async = true;
    script.type = 'text/javascript';
    document.head.appendChild(script);
    // Create the wrapper and widget
    const wrapper = document.createElement('div');
    wrapper.className = 'elevenlabs-widget-wrapper';
    const widget = document.createElement('elevenlabs-convai');
    widget.setAttribute('agent-id', agentId);
    widget.setAttribute('variant', 'full');
    
    //hide widget initially
    widget.style.display = "none";

    //overrides
    if(firstMessage) widget.setAttribute('override-first-message', firstMessage);

    // Set initial colors and variant based on current theme and device
    updateWidgetVariant(widget);

    // Add resize listener for mobile detection
    window.addEventListener('resize', () => {
        updateWidgetVariant(widget);
    });
    function updateWidgetVariant(widget) {
        const isMobile = window.innerWidth <= 640; // Common mobile breakpoint
        if (isMobile) {
            widget.setAttribute('variant', 'expandable');
        } else {
            widget.setAttribute('variant', 'full');
        }
    }


    // Attach widget to the DOM
    wrapper.appendChild(widget);
    document.body.appendChild(wrapper);
}

document.addEventListener('DOMContentLoaded', function(){
    const elevenlabsTrigger = document.querySelector('.js-elevenlabs-trigger');

    if(elevenlabsTrigger){

        const agentId = elevenlabsTrigger.dataset.agent;
        const firstMessage = elevenlabsTrigger.dataset.firstMessage || false;

        const options = {
            firstMessage
        }

        injectElevenLabsWidget(agentId, options);

        elevenlabsTrigger.addEventListener('click', function(e){
            console.log('trigger clicked');
            const elevenlabsWidget = document.querySelector('elevenlabs-convai');
            if(elevenlabsWidget){

                //if widget is already shown, return
                if(elevenlabsWidget.style.display == "block") return;

                //show widget 
                elevenlabsWidget.style.display = "block";
                const shadow = elevenlabsWidget.shadowRoot;

                if(shadow){
                    //hide chat support widget to prevent overlap
                    theme.ChatWidget.hide();

                    //add class to body so support widget won't show up
                    document.querySelector('body').classList.add('elevenlabs-widget-enabled')

                    //shadow.querySelector('button').click();

                    //e.stopPropagation();
                }
            }
        })
    }
})